@keyframes slide-down {
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
}

@keyframes slide-up {
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
}

.right-container {
  display: flex;
  gap: 1.2rem;
  align-items: center;
  min-width: max-content;
}

.title {
  color: var(--color-grayscale-white);
  font-size: 1.3rem;
  font-weight: 400;
  overflow: hidden;
}

.header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.4rem;
  background: var(--color-surface-secondary);
  cursor: pointer;
  gap: 1.6rem;
  color: #e3e4e7;

  &[data-transparent='true'] {
    background: transparent;
  }

  &[data-align='center'] {
    justify-content: center;

    .right-container {
      position: absolute;
      top: 0.8rem;
      right: 1.6rem;

      @media screen and (min-width: $bp-medium) {
        top: 1.2rem;
        right: 2.4rem;
      }
    }
  }

  @media screen and (min-width: $bp-medium) {
    height: 4rem;
    padding: 0 1.6rem;
  }

  &[data-padding='none'] {
    padding: unset;

    & .title {
      line-height: unset;
    }
  }
}

.trigger {
  .trigger-chevron {
    transition: transform 300ms cubic-bezier(0.87, 0, 0.13, 1);
  }

  &[data-state='open'] .trigger-chevron {
    transform: rotate(180deg);
  }
}

.content {
  overflow: hidden;

  &[data-state='open'] {
    animation: slide-down 300ms cubic-bezier(0.87, 0, 0.13, 1);
  }

  &[data-state='closed'] {
    animation: slide-up 300ms cubic-bezier(0.87, 0, 0.13, 1);
  }
}
